module.exports = __webpack_public_path__ + "static/media/em-105.740e6a5c.png";